import { render } from "./CollapseTransition.vue?vue&type=template&id=63e573f1"
import script from "./CollapseTransition.vue?vue&type=script&lang=js"
export * from "./CollapseTransition.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__